import { useEffect, useState } from 'react';

export default function useHudVisibility() {
  const [mode, setMode] = useState<'visible' | 'dock' | 'clean'>('visible');
  useEffect(() => {
    const toggle = (event: KeyboardEvent) => {
      if (!event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.repeat) return;
      const key = event.key.toLowerCase();
      if (key !== 'c' && key !== 'h') return;
      // Preserve normal copying in chat/forms or when text is selected.
      const target = event.target;
      if (target instanceof Element && target.closest('input,textarea,select,[contenteditable="true"],[role="textbox"]')) return;
      if (key === 'c' && window.getSelection()?.toString()) return;
      event.preventDefault();
      setMode(current => current === 'visible' ? (key === 'c' ? 'clean' : 'dock') : 'visible');
    };
    window.addEventListener('keydown', toggle, true);
    return () => window.removeEventListener('keydown', toggle, true);
  }, []);
  return { hidden: mode !== 'visible', showRestore: mode === 'dock', hide: () => setMode('dock'), show: () => setMode('visible') };
}
